export default __webpack_public_path__ + "static/media/photo03_sp.5fa9dfe5.jpg";